export const site = {
  legalName: "Immistop Global Migration Advisory Private Limited",
  brand: "Immistop",
  offices: [
    { label: "India", city: "Ahmedabad", lines: ["904, Fortune Business Hub", "Science City, Ahmedabad 380060", "Gujarat, India"], phone: "+44 7827525637", tz: "Asia/Kolkata", tzLabel: "IST", hoursText: "Monday to Saturday, 10:00 to 19:00", days: [1, 2, 3, 4, 5, 6], open: 10 * 60, close: 19 * 60, map: "https://www.google.com/maps?q=Fortune%20Business%20Hub%2C%20Science%20City%2C%20Ahmedabad%20380060&output=embed" },
    { label: "United Kingdom", city: "Colchester", lines: ["18, Peter Crowe Approach", "Stanway, Colchester CO3 8BN", "United Kingdom"], phone: "+44 7412077076", tz: "Europe/London", tzLabel: "UK time", hoursText: "Monday to Friday, 09:00 to 17:30", days: [1, 2, 3, 4, 5], open: 9 * 60, close: 17 * 60 + 30, map: "https://www.google.com/maps?q=18%20Peter%20Crowe%20Approach%2C%20Stanway%2C%20Colchester%20CO3%208BN&output=embed" },
  ],
  email: "enquiries@immistop.com",
  whatsapp: "447827525637",
  whatsappDisplay: "+44 7827525637",
};

export const telHref = (p) => `tel:${p.replace(/\s/g, "")}`;

export const whatsappLink = (text = "Hello Immistop, I would like to arrange a private consultation.") =>
  `https://wa.me/${site.whatsapp}?text=${encodeURIComponent(text)}`;

export const trustStats = [
  { value: "20+", label: "Years of experience" },
  { value: "35+", label: "Countries covered" },
  { value: "99%", label: "Success rate" },
  { value: "1,500+", label: "Clients served" },
];

export const pillars = [
  { title: "Personalised Strategy", icon: "Compass", text: "Every engagement begins with your goals, not a template. Strategies are designed around your profile, family and timeline." },
  { title: "Compliance-First", icon: "ShieldCheck", text: "We work strictly within the law and current official guidance. Accuracy and honesty are non-negotiable in every file." },
  { title: "End-to-End Support", icon: "Route", text: "From first consultation to arrival and settlement, a dedicated adviser stays with you at every stage." },
  { title: "Absolute Confidentiality", icon: "Lock", text: "Your personal, financial and family information is handled with the discretion of a private bank." },
  { title: "Transparent Pricing", icon: "Scale", text: "Clear, written engagement terms agreed in advance, with no hidden charges and no surprises." },
];

export const processSteps = [
  { n: "01", title: "Consultation", text: "A private conversation to understand your aspirations, circumstances and preferred destinations." },
  { n: "02", title: "Strategy", text: "A written route recommendation with indicative timelines, documents and next steps, subject to eligibility." },
  { n: "03", title: "Application", text: "Meticulous preparation, review and submission of your application and supporting evidence." },
  { n: "04", title: "Arrival & Settlement", text: "Pre-departure briefings, settlement support and ongoing compliance in your new home." },
];

export const testimonials = [
  { quote: "Immistop approached our family's relocation with the discretion and precision we expect from our private bankers. Every step was explained before it happened.", name: "[Client Name]", role: "Business owner · Relocated to the United Kingdom" },
  { quote: "Their candour stood out. They told us which routes were realistic and which were not, and that honesty is exactly why we trusted them.", name: "[Client Name]", role: "Senior technology professional · Canada" },
  { quote: "From the first consultation to our first week in Auckland, we always knew who to call. The settlement support was invaluable.", name: "[Client Name]", role: "Physician and family · New Zealand" },
  { quote: "The documentation process for our investor application was complex. Immistop kept it organised, calm and entirely confidential.", name: "[Client Name]", role: "Investor · European residence" },
];

export const values = [
  { title: "Integrity", text: "We say what is true, even when it is not what a client hopes to hear." },
  { title: "Discretion", text: "Confidentiality is a standard we practise, not a promise we print." },
  { title: "Precision", text: "Every detail is checked, every document reviewed, every deadline tracked." },
  { title: "Care", text: "Migration is personal. We treat every family's future as if it were our own." },
];

export const team = [
  { name: "[Founder Name]", role: "Founder & Managing Director" },
  { name: "[Name]", role: "Head of Investor Migration" },
  { name: "[Name]", role: "Head of Skilled Migration" },
  { name: "[Name]", role: "Client Relations Director" },
];

export const credentials = [
  "[Registration / licence number — to be provided]",
  "[Professional body membership — to be provided]",
  "Registered in India as a Private Limited Company",
  "Data handled in line with applicable Indian data-protection law",
];

export const generalFaqs = [
  { q: "Do you guarantee visa approvals?", a: "No. Immigration decisions rest solely with the relevant government authorities. We help you present the strongest, most accurate application possible, subject to eligibility." },
  { q: "How do your fees work?", a: "Fees depend on the scope of your matter and are confirmed in a written engagement letter before any work begins. There are no hidden charges." },
  { q: "Can I consult with you by video?", a: "Yes. We offer in-person consultations in Ahmedabad, as well as video and telephone consultations for clients anywhere in the world." },
  { q: "Is my information kept confidential?", a: "Absolutely. Client information is shared only with your consent and only where necessary to progress your matter." },
];

export const countryCodes = ["+91", "+971", "+44", "+1", "+61", "+64", "+65", "+852", "+966", "+974", "+49", "+33", "+351", "+353", "+27"];
